import { Typography } from '@mui/material';

export default function Description({ dsc }) {
  return (
    <Typography
      sx={{
        fontSize: '14px',
        fontWeight: '400',
        marginTop: '8px !important',
        textAlign: 'justify',
      }}
      whiteSpace="pre-wrap"
    >
      {dsc}
    </Typography>
  );
}
